import { useState, useEffect } from 'react';

export default function useScrollSpy(sectionIds, offset = 100) {
    const [active, setActive] = useState(sectionIds[0] || '');

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY + offset;
            let current = sectionIds[0];

            for (const id of sectionIds) {
                const el = document.getElementById(id);
                if (el && el.offsetTop <= scrollY) {
                    current = id;
                }
            }
            setActive(current);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);

    return active;
}
